import { number, object, string } from "yup";

import { IStockMovement, IStockMovementInput } from "@/interfaces/sku-movement.interfaces";
import { SkuMovementMessages } from "@/messages/sku/sku-movement.messages";

export enum Type {
  ENTRY = "ENTRY",
  OUT = "OUT",
}

export enum MovementType {
  ORDER = "ORDER",
  PRODUCT = "PRODUCT",
  INTEGRATION = "INTEGRATION",
}

export const buildStockMovementInitialData = (
  stockMovement: IStockMovementInput | undefined
): IStockMovement => {
  return {
    id: 0,
    rowDate: new Date(),
    deletedDate: new Date(),
    skuId: stockMovement?.skuId || 0,
    movementType: stockMovement?.movementType || MovementType.ORDER,
    type: stockMovement?.type || Type.ENTRY,
    movementDate: stockMovement?.movementDate || new Date(),
    quantity: stockMovement?.quantity || 0,
    comments: stockMovement?.comments || "",
    documentNumber: stockMovement?.documentNumber || "",
  };
};

export const buildStockMovementFormSchema = (messages: SkuMovementMessages) =>
  object().shape({
    type: string().required(messages.errorRequiredType),
    quantity: number()
      .required(messages.errorRequiredQuantity)
      .positive(messages.errorQuantityGreaterThanZero),
    comments: string().required(messages.errorRequiredComments),
  });

export const normalizeStockMovementData = (
  formData: IStockMovementInput,
  skuId: number
): IStockMovementInput => {
  return {
    ...formData,
    skuId: skuId,
    movementType: MovementType.ORDER,
    documentNumber: skuId.toString(),
  };
};
